import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import darkTheme from "./themes/darkTheme";
import lightTheme from "./themes/lightTheme";
import styles from "./App.module.scss";
import RouteComponent from "./routes/RouteComponent";
import { ErrorBoundary } from "react-error-boundary";
import Errorhandlingcomponent from "./errorHandling/ErrorHandlingComponent";
import { ApiErrorModalProvider } from "./errorHandling/ApiErrorModalContext";
import { ApiErrorModal } from "./errorHandling/ApiErrorModal";
import { NavbarProvider } from "./components/navbar/NavbarCotext";
import { AuthProvider } from "./auth/AuthContext";

function App() {
  const themeMode = "light";

  return (
    <div className={styles.App} data-testid="App">
      <ThemeProvider theme={themeMode === "light" ? lightTheme : darkTheme}>
        <CssBaseline />
        <ApiErrorModalProvider>
          <AuthProvider>
            {/* adding a context before in coming sprint needed */}
            <NavbarProvider>
              <ErrorBoundary FallbackComponent={Errorhandlingcomponent}>
                <ApiErrorModal />
                <RouteComponent />
              </ErrorBoundary>
            </NavbarProvider>
          </AuthProvider>
        </ApiErrorModalProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
